import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M11.458.16a1 1 0 0 1 1.084 0l10 6.444a1 1 0 0 1 .456.896H23v10h-.134a.995.995 0 0 1-.351.358l-10 6a1 1 0 0 1-1.03 0l-10-6a.996.996 0 0 1-.351-.358H1v-10h.002L1 7.477a1 1 0 0 1 .457-.873l10-6.445ZM3 9.143v7.29l8 4.8v-7.646L3 9.144Zm10 4.444v7.646l8-4.8v-7.29l-8 4.444Zm7.055-6.207L12 2.19 3.945 7.38 12 11.857l8.055-4.475Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
